<template class="bg-gray-300">
  <div>
    <div class="bg-gray-200 py-2">
      <div class="breadcrumbs container mx-auto">
        <nuxt-link :to="localePath('index')" class="breadcrumb  px-2">
          {{ $t('home') }}</nuxt-link
        >
        <nuxt-link :to="localePath('news')" class="breadcrumb  px-2">
          {{ $t('news') }}</nuxt-link
        >
      </div>
    </div>
    <div class="bg-gray-300 py-8">
      <div class="container px-4 mx-auto">
        <div v-for="(post, index) in posts" :key="index" class="post">
          <div class="news items-center bg-white shadow-md p-8">
            <div>
              <div class="solution items-center flex-col md:flex-row">
                <p class="text-gray-500">{{ post.date }}</p>
                <h3 class="text-2xl text-black font-bold mt-0 mb-4">
                  {{ post.name }} 
                </h3>
                <div
                  v-html="post.content"
                  class="post-content text-sm h-64 md:h-20 text-justify overflow-hidden text-gray-900 text-light mb-12"
                ></div>
                <nuxt-link
                  :to="
                    localePath({
                      name: 'post-slug',
                      params: { slug: post.slug  }
                    })
                  "
                  class="bg-blue-600 hover:bg-blue-700 px-12 uppercase hover:text-white mt-6 text-white px-5 py-3"
                  >{{ $t('read_more') }}</nuxt-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import postsJSON from '~/static/posts.json'

export default {
  head() {
    // Definišemo kanonski link direktno
    const canonicalLink = {
      rel: 'canonical',
      href: `https://milsped.com${this.$route.path}/` // Osigurajte da je ovo vaša osnovna domena
    }

    // Vraćamo objekat head sa kanonskim linkom
    return {
      link: [canonicalLink]
    }
  },
  data() {
    return {}
  },
  computed: {
    languagePrefix() {
      return this.$i18n.locale !== 'en' ? this.$i18n.locale + '/' : ''
    },
    lang() {
      return this.$i18n.locale
    },
    posts() {
      return postsJSON.filter(post => {
        return post.lang === this.lang
      })
    }
  }
}
</script>

<style scoped>
.news {
  /* height: 380px; */
  /* @apply max-w-xs; */
  @apply p-4;
}

.news img {
  display: none;
}
.news.active {
  display: flex;
  opacity: 1;
  width: 100%;
}
.news.active img {
  display: block;
}

img {
  width: 100%;
  height: auto;
  /* margin-bottom: 15px; */
  margin-bottom: 14px;
}
.post {
  margin-bottom: 15px;
}
@screen md {
  .news img {
    width: 50%;
    height: auto;
    height: 450px;
    object-fit: cover;
  }
  .news.active > div {
    /* width: 50%; */
  }
}

.glide__slide > div {
  padding: 20px;
}

@screen md {
  .news {
    max-width: unset;
  }
}
img {
  width: 100%;
  height: auto;
  margin-bottom: 15px;
}

.post-content {
  position: relative;
  height: 7.2em; /* exactly three lines */
}
.post-content:after {
  content: '';
  text-align: right;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 1.2em;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 1) 50%
  );
}
</style>
